import React from "react";
import { Bar, ComposedChart, XAxis, ResponsiveContainer } from "recharts";
import GraphLoader from "../../components/GraphLoader";
import { useMemo } from "react";

const PvsystActualGTIContainer = ({
  GHIGTI,
  loading,
  progressValueAnimate,
  setProgressValueAnimate,
}) => {

    const filteredData = useMemo(() => {
      if (GHIGTI?.length > 0) {
        return {
          pvsystGIISum: Number(
            Number(
              GHIGTI?.reduce((acc, curr) => acc + (curr?.["PVsyst GII"] || 0), 0)
            ).toFixed(2)
          ),
          actualGIISum: Number(
            Number(
              GHIGTI?.reduce((acc, curr) => acc + (curr?.["Actual GII"] || 0), 0)
            ).toFixed(2)
          ),
          pvsystGIILen: GHIGTI?.reduce(
            (acc, curr) => acc + (curr?.["PVsyst GII"] ? 1 : 0),
            0
          ),
          actualGIILen: GHIGTI?.reduce(
            (acc, curr) => acc + (curr?.["Actual GII"] ? 1 : 0),
            0
          ),
        };
      }
      return {
        pvsystGIISum: null,
        actualGIISum: null,
        pvsystGIILen: 0,
        actualGIILen: 0,
      };
    }, [GHIGTI]);
  return (
    <div className="detail_overview_1">
      {loading ? (
        <div style={{ height: "100%", width: "100%" }}>
          <GraphLoader />
        </div>
      ) : !GHIGTI || GHIGTI?.length == 0 ? (
        <div style={{ height: "100%", width: "100%", fontSize: "2vmin" }}>
          <p>PVsyst GII (kWh/m^2) and Actual GII</p>
          <p>Data Not Available</p>
        </div>
      ) : (
        <>
          <div>
            <span style={{position:"absolute",fontSize:"0.8rem", top: 0, left: 0,right:0 }}>{GHIGTI?.[0]?.Date} to {GHIGTI?.[GHIGTI?.length-1]?.Date}</span>

            <div>
              <div>
                <progress
                  className="progress_1"
                  style={{
                    accentColor: "green",
                    borderRadius: "14px",
                    border: progressValueAnimate.progress1
                      ? "3px solid red"
                      : "none",
                  }}
                  value={filteredData?.pvsystGIISum}
                  max={Math.ceil(filteredData?.pvsystGIISum) + 100 || 0}
                />
              </div>
              <div>
                <span>PVsyst GII (kWh/m^2)</span>
                <span
                  style={{
                    position: "absolute",
                   left: `${
                      (filteredData?.pvsystGIISum * 100) /
                        Math.ceil(filteredData?.pvsystGIISum + 100) -
                      3
                    }%`,
                    bottom: "60%",
                  }}
                >
                  <i class="fa-solid fa-caret-up"></i>
                </span>

                <span>
                  <span>{filteredData.pvsystGIISum || "N/A"}</span>
                </span>
              </div>
            </div>
            <div>
              <div>
                <progress
                  className="progress_2"
                  style={{
                    accentColor: "green",
                    borderRadius: "14px",
                    border: progressValueAnimate.progress2
                      ? "3px solid black"
                      : "none",
                  }}
                  value={filteredData.actualGIISum}
                  max={filteredData.actualGIISum + 100}
                />
              </div>
              <div>
                <span>Actual GII (kWh/m^2)</span>
                <span
                  style={{
                    position: "absolute",
                     left: `${
                      (filteredData?.actualGIISum * 100) /
                        (Math.ceil(filteredData?.actualGIISum) + 100) -
                      3
                    }%`,
                    bottom: "60%",
                  }}
                >
                  <i class="fa-solid fa-caret-up"></i>
                </span>
                  <span>{filteredData?.actualGIISum || "N/A"}</span>
              </div>
            </div>
            <div>
              <div>
                <progress
                  className="progress_3"
                  style={{ accentColor: "green" }}
                 value={
                    filteredData?.pvsystGIISum && filteredData?.actualGIISum
                      ? ((filteredData?.pvsystGIISum -
                          filteredData?.actualGIISum) *
                          100) /
                        filteredData?.pvsystGIISum
                      : 0
                  }
                  max="100"
                />
              </div>
              <div>
                <span>Excess(+)/ShortFall(-) (%)</span>
                <span
                  style={{
                    position: "absolute",
                     left: `${
                      Math.abs(
                        filteredData?.pvsystGIISum && filteredData?.actualGIISum
                          ? ((filteredData?.actualGIISum -
                              filteredData?.pvsystGIISum) *
                              100) /
                              filteredData?.pvsystGIISum
                          : 0
                      ) - 3
                    }%`,
                    bottom: "60%",
                  }}
                >
                  <i class="fa-solid fa-caret-up"></i>
                </span>
                <span>
                  {filteredData?.pvsystGIISum && filteredData?.actualGIISum
                    ? Number(
                        Number(
                          ((filteredData?.actualGIISum -
                            filteredData.pvsystGIISum) *
                            100) /
                            filteredData?.pvsystGIISum
                        ).toFixed(2)
                      )
                    : "N/A"}
                </span>
              </div>
            </div>
          </div>
          <div>
            <div>
              <span>
               {filteredData.pvsystGIISum || "N/A"}
              </span>
              <span>PVsyst GII (kWh/m^2) </span>
              <div style={{ width: "80%", height: 30 }}>
                <ResponsiveContainer>
                  <ComposedChart
                    margin={{
                      top: 0,
                      bottom: 0,
                      left: 0,
                      right: 0,
                    }}
                    data={GHIGTI || []}
                  >
                    <XAxis dataKey="Date" hide />
                    {/* <Tooltip/> */}
                    {/* <Tooltip content={<CustomizeTootip active={false} payload={[]} label={""} TooltipValues={["PVsyst GTI"]} />} /> */}
                    <Bar
                      barSize={4}
                      radius={14}
                      dataKey="PVsyst GII"
                      fill="#8884d8"
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
              <span
                className="progress_button_1"
                onMouseEnter={() =>
                  setProgressValueAnimate({
                    ...progressValueAnimate,
                    progress1: true,
                  })
                }
                onMouseOut={() =>
                  setProgressValueAnimate({
                    ...progressValueAnimate,
                    progress1: false,
                  })
                }
              >
                View
              </span>
            </div>
            <div>
              <span>
                {Number( parseFloat(
                  GHIGTI?.reduce(
                    (acc, curr) =>curr["Actual GII"]? acc + curr["Actual GII"]:acc,
                    0
                  )
                ).toFixed(2) || 0)}
              </span>
              <span>Actual GII (kWh/m^2) </span>
              <div style={{ width: "80%", height: 30 }}>
                <ResponsiveContainer>
                  <ComposedChart
                    margin={{
                      top: 0,
                      bottom: 0,
                      left: 0,
                      right: 0,
                    }}
                    data={GHIGTI || []}
                  >
                    <XAxis dataKey="Date" hide />
                    {/* <Tooltip content={<CustomizeTootip active={false} payload={[]} label={""} TooltipValues={["Actual GTI"]} />} /> */}
                    <Bar
                      barSize={4}
                      radius={14}
                      dataKey="Actual GII"
                      fill="#8884d8"
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
              <span
                onMouseEnter={() =>
                  setProgressValueAnimate({
                    ...progressValueAnimate,
                    progress2: true,
                  })
                }
                onMouseOut={() =>
                  setProgressValueAnimate({
                    ...progressValueAnimate,
                    progress2: false,
                  })
                }
                className="progress_button_2"
              >
                View
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PvsystActualGTIContainer;
